<template>
  <div>
    <section class="main">
      <div class="inner cg">
        <h1>Which Program is Best for You?</h1>
      </div>
    </section>
    <section class="info">
      <div class="cg">
        <p>
          Choosing the Residency or Citizenship Program that best suits your needs can
          be complex, especially when there are so many options available to you. We,
          therefore, encourage you to consider the following tips before deciding on a
          Program and to help you make the right choice.
        </p>
        <options v-animate.fade="'slide-up'"/>
      </div>
    </section>
    <section class="compare">
      <div class="inner cg">
        <h3>Product Comparison</h3>
        <pdf
          height="750px"
          path="/compare.pdf" 
          label="Download comparison table"/>
        <compare-table/>
        <p>
          Additional state fee and additional amount of donation would be added
          depending from the amount of family members
          <br>
          ** Additional state fee would be added depending from the amount of
          family members
        </p>
      </div>
    </section>
    <contact/>
  </div>
</template>

<script>
import Options from '@/components/options';
import Pdf from '@/components/pdf';
import CompareTable from '@/components/compare-table';
import Contact from '@/components/contact-bar';

export default {
  components: { Options, Pdf, CompareTable, Contact },
};
</script>

<style lang="scss" scoped>
@import '@/assets/mixins.scss';

section {
  padding: 40px 0;
}

h1 {
  color: #131e43;
  font-weight: 400;
  
  @include mobile {
    line-height: 44px;
    font-size: 32px;
  }

  @include desktop {
    max-width: 550px;
  }
}

.main {
  @include mobile {
    padding-top: 380px;
    background: #f9f9f9 url('../assets/compare.png') no-repeat top -20px center;
    background-size: 420px auto;
  }

  @include desktop {
    padding: 0;
  }

  .inner {
    position: relative;

    @include desktop {
      padding: 80px 20px;
    }

    &:after {
      position: absolute;
      top: 10px;
      right: 0;
      background: url('../assets/compare.png') no-repeat center;
      width: 468px;
      height: 471px;

      @include desktop {
        content: '';
      }
    }
  }
}

.info {
  background: #f9f9f9;

  @include mobile {
    padding-top: 0;
  }

  p {
    color: #131e43;
    margin-bottom: 40px;

    @include desktop {
      padding-right: 500px;
    }
  }
}

.compare {
  background: #eff8fe;

  .inner {
    display: flex;
    flex-direction: column;
  }

  p {
    margin-top: 20px;
    font-size: 14px;
    color: #a3a4a6;
  }
}
</style>